import React from 'react';
import SubHeader from '../../layout/components/SubHeader';
import TabCard from './clinicsettings/TabCard';
import './ClinicSettings.css';

function ClinicSettings() {
    return (
        <div className="ecx-page clinic-settings-page ecx-page--full-width">
            <SubHeader
                title="Clinic Settings"
                description="Manage clinic profile, hours, recalls, brands, social links, appointment notes, and web booking"
                icon="bi-building"
                containerClass="w-100 px-4"
            />

            <div className="ecx-page-body">
                <TabCard />
            </div>
        </div>
    );
}

export default ClinicSettings;
